export default function generateCSSRule(selector, cssDeclaration) {
  return selector + "{" + cssDeclaration + "}";
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-tools/node_modules/fela-utils/es/generateCSSRule.js
// module id = 259
// module chunks = 0